import { TableColumn } from "../table.column";
import { TableElement } from "../table.element";
import { ProgressComponent } from "./progress.component";

export class ProgressTableColumn extends TableColumn {
	color: string;
	mode: string;
	bufferValueColumn: string;
	width = 150;
	height = 20;

	public constructor(column: string, title: string, color?: string, mode?: string, bufferValueColumn?: string) {
		super(column, title, false);

		this.color = color;
		this.mode = mode;
		this.bufferValueColumn = bufferValueColumn;
		this.type = ProgressComponent;
	}

	public withMode(mode: string): ProgressTableColumn {
		this.mode = mode;
		return this;
	}

	public withBufferValueColumn(bufferValueColumn: string): ProgressTableColumn {
		this.bufferValueColumn = bufferValueColumn;
		return this;
	}

	public withWidth(width: number) {
		this.width = width;
		return this;
	}

	public withHeight(height: number) {
		this.height = height;
		return this;
	}

	getQuantity(elementData: any) {
		return this.getContent(elementData);
	}
}

export class QuotaProgressTableColumn extends ProgressTableColumn {
	currentColumn: string;

	constructor(column: string, currentColumn: string, title: string) {
		super(column, title);

		this.currentColumn = currentColumn;
		this.withFixed(2);
		this.withStyles('cellCenter tableStatus');
		this.withIgnoreSort(true);
		this.withDecorator((column: TableColumn, element: TableElement) => {
			const max = TableColumn._getData(element.getData(), this.column);
			const current = TableColumn._getData(element.getData(), this.currentColumn);

			return (max ? (current / max * 100).toFixed(this.fixedLength) : Number(0).toFixed(this.fixedLength));
		});
	}

	getQuantity(elementData: any) {
		const currentValue = TableColumn._getData(elementData, this.currentColumn);
		const totalValue = TableColumn._getData(elementData, this.column);

		if (typeof currentValue === 'undefined') {
			const zeroValue = new Number(0).toFixed(this.fixedLength);

			return zeroValue + ' / ' + zeroValue;
		} else if (typeof totalValue === 'undefined') {
			const zeroValue = new Number(0).toFixed(2);
			
			return (currentValue.toFixed(this.fixedLength) + ' / ' + zeroValue);
		} else {
			return (currentValue.toFixed(this.fixedLength) + ' / ' + totalValue.toFixed(this.fixedLength));
		}
	}
}
